import { AxiosError } from 'axios';
import { ErrorMessage } from './ErrorMessage.dto';

export const extractMessageFromError = (error: any): string => {
  const axiosError = error as AxiosError<ErrorMessage>;
  const msg = axiosError.response?.data?.message;
  if (msg) {
    return msg;
  } else {
    return axiosError?.message ? axiosError?.message : 'UNKNOWN ERROR!';
  }
};

export const extractStatusFromError = (error: any): number | undefined => {
  const axiosError = error as AxiosError<ErrorMessage>;
  return axiosError.response?.status ? axiosError.response.status : 0;
};
